var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 44,
    width: 44,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#0066cc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,0C153.755,0,70.573,83.182,70.573,185.426c0,126.888,165.939,313.167,173.004,321.035 c6.636,7.391,18.222,7.378,24.846,0c7.065-7.868,173.004-194.147,173.004-321.035C441.425,83.182,358.244,0,256,0z M256,278.719 c-51.442,0-93.292-41.851-93.292-93.293S204.559,92.134,256,92.134s93.291,41.851,93.291,93.293S307.441,278.719,256,278.719z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 188,
    r: 128
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    transform: "matrix(0.38,0,0,0.38,162,90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m63.644 366.183c-35.094 0-63.644 28.55-63.644 63.643 0 35.094 28.55 63.645 63.644 63.645s63.644-28.551 63.644-63.645c-.001-35.093-28.551-63.643-63.644-63.643z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.849 366.282-64.371-347.753h-80.426v30h55.469l43.065 232.646-53.575 98.251h-209.474c9.333 14.559 14.75 31.858 14.75 50.399 0 14.95-3.527 29.089-9.784 41.639h188.491l78.251-143.508 8.108 43.803c-22.162 9.964-37.641 32.235-37.641 58.066 0 35.094 28.551 63.645 63.644 63.645s63.644-28.55 63.644-63.644c0-33.92-26.677-61.723-60.151-63.544z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlue);
export default __webpack_public_path__ + "static/media/blue.4592156a75c128c268b3f508bf335e05.svg";
export { ForwardRef as ReactComponent };